<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-blue">
    <Events
        v-if="$route.name === names.CALENDAR.PAGE"
    />
    <router-view v-else />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import Events from "@/modules/personal_account/calendar/pages/Events.vue"
import names from "@/modules/personal_account/routers/names"

export default defineComponent({
  name: "EventsBase",
  computed: {
    names () {
      return names
    }
  },
  components: { Events }
})
</script>

<style scoped lang="scss">

</style>
